/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：646
 */

export const BINDING = {
  Blink: Symbol("Blink"),
  block_animations: Symbol("block_animations"),
  touch_manager: Symbol("touch_manager"),
  dragged_connection_manager: Symbol("dragged_connection_manager"),
  insertion_marker_manager: Symbol("insertion_marker_manager"),
  utils: Symbol("utils"),
  xml: Symbol("xml"),
  registry: Symbol("registry"),
  json: Symbol("json"),
  css_content: Symbol("css_content"),
  css: Symbol("css"),
  widget_div: Symbol("widget_div"),
  runtime_data: Symbol("runtime_data"),
  context_menu: Symbol("context_menu"),
  events: Symbol("events"),
  extensions: Symbol("extensions"),
  slider_controller: Symbol("slider_controller"),
  angle_controller: Symbol("angle_controller"),
  color_controller: Symbol("color_controller"),
  WorkspaceElementDragger: Symbol("WorkspaceElementDragger"),
  FlyoutDragger: Symbol("FlyoutDragger"),
  WorkspaceDragger: Symbol("WorkspaceDragger"),
  Inject: Symbol("Inject"),
  Msg: Symbol("Msg"),
  WorkspaceDragSurfaceSvg: Symbol("WorkspaceDragSurfaceSvg"),
  BlockSvg: Symbol("BlockSvg"),
  BlockDragSurfaceSvg: Symbol("BlockDragSurfaceSvg"),
  ConnectionDB: Symbol("connection_db"),
  WorkspaceSvg: Symbol("WorkspaceSvg"),
  WorkspaceAudio: Symbol("WorkspaceAudio"),
  EndDragEvent: Symbol("EndDragEvent"),
  StartDragEvent: Symbol("StartDragEvent"),
  MoveEvent: Symbol("MoveEvent"),
  ChangeEvent: Symbol("ChangeEvent"),
  UIEvent: Symbol("UIEvent"),
  CreateEvent: Symbol("CreateEvent"),
  DeleteEvent: Symbol("DeleteEvent"),
  DragAreaChangeEvent: Symbol("DragAreaChangeEvent"),
  ContextMenuOptionEvent: Symbol("ContextMenuOptionEvent"),
  GroupEvent: Symbol("GroupEvent"),
  FlyoutButton: Symbol("FlyoutButton"),
  VerticalFlyout: Symbol("VerticalFlyout"),
  Field: Symbol("Field"),
  FieldImage: Symbol("Image"),
  FieldIcon: Symbol("Icon"),
  FieldLabel: Symbol("Label"),
  FieldLabelSerializable: Symbol("LabelSerializable"),
  FieldDropdown: Symbol("Dropdown"),
  FieldButton: Symbol("FieldButton"),
  FieldColour: Symbol("FieldColour"),
  FieldTextInput: Symbol("FieldTextInput"),
  FieldTextDropdown: Symbol("FieldTextDropdown"),
  FieldNumber: Symbol("FieldNumber"),
  FieldMultilineInput: Symbol("FieldMultilineInput"),
  FieldDefaultValue: Symbol("FieldDefaultValue"),
  Toolbox: Symbol("Toolbox"),
  MutationAddButton: Symbol("MutationAddButton"),
  MutationRemoveButton: Symbol("MutationRemoveButton"),
  Scrollbar: Symbol("Scrollbar"),
  ScrollbarPair: Symbol("ScrollbarPair"),
  Grid: Symbol("Grid"),
  Comment: Symbol("Comment"),
  Bubble: Symbol("Bubble"),
  Gesture: Symbol("Gesture"),
  RenderedConnection: Symbol("RenderedConnection"),
  Input: Symbol("Input"),
  Options: Symbol("Options"),
  Warning: Symbol("Warning"),
  tooltip: Symbol("tooltip"),
  theme: Symbol("theme"),
  WorkspaceComment: Symbol("WorkspaceComment"),
  BlockGroup: Symbol("BlockGroup"),
  SimplifiedCommentBubble: Symbol("SimplifiedCommentBubble"),
  workspace_db: Symbol("workspace_db")
}
